/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type JdbcDatasourceConnectionParams = {
    properties: Record<string, string>;
    type: JdbcDatasourceConnectionParams.type;
    url: string;
};

export namespace JdbcDatasourceConnectionParams {

    export enum type {
        USER_PASSWORD = 'USER_PASSWORD',
        USER_PRIVATE_KEY = 'USER_PRIVATE_KEY',
        OAUTH2_MICROSOFT_ENTRA_ID = 'OAUTH2_MICROSOFT_ENTRA_ID',
        SNOWFLAKE_NATIVE_APP = 'SNOWFLAKE_NATIVE_APP',
    }


}
